export default __webpack_public_path__ + "static/media/EnergyGenerationIcon.f2d09d47.svg";